import React from "react";
import { Typography, Box, List, ListItem, ListItemText, Divider, Grid, Button, Chip } from "@mui/material";

const Activities = ({ prevStep, nextStep }) => {
  const rules = [
    "Share with staff the activities you would like to do",
    "Plan activities for the week in your weekly meeting",
    "Some activities will be educational to support your educational learning",
    "Be careful of the windows when using activity equipment",
    "If you use activity items, place them away after use",
  ];

  return (
    <Box className='house-rules-container'>
      <Box className='header-section-house'>
        <Chip label='Admission' />

        <Typography sx={{ fontSize: "22px", fontWeight: "bold", color: "black" }} align='left' mt={1}>
          House Rules
        </Typography>
        <br />
        <Divider className='divider' />
      </Box>
      <Box className='content-section'>
        <Typography sx={{ fontSize: "16px", fontWeight: "bold", color: "black" }} align='left'>
          Activities
        </Typography>
        <Typography sx={{ fontSize: "14px" }}>
          "Engage in weekly planned activities and ensure that all equipment is stored and used safely."
        </Typography>
        <List className='rules-list'>
          {rules.map((rule, index) => (
            <ListItem key={index} className='rule-item'>
              <ListItemText primary={<Typography sx={{ fontSize: "14px", color: "black" }}>{rule}</Typography>} />
            </ListItem>
          ))}
        </List>
      </Box>
      <Grid container justifyContent='space-between' alignItems='center' mt={2} ml={1} mr={2}>
        <Grid item>
          <Button type='button' variant='contained' color='primary' onClick={prevStep}>
            Previous
          </Button>
        </Grid>
        <Grid item>
          <Button type='button' variant='contained' color='primary' onClick={nextStep}>
            Next
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Activities;
